export default __webpack_public_path__ + "static/ball_detect-76490e63465eaf3f63e80b724eeb14e3.png";